/**
 * @generated SignedSource<<d376396ae27508dec6ceda1544f4a758>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MemberStatusValue = "DELETED" | "INVITED" | "PENDING_INVITATION" | "REGISTERED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExplicitOwners_ownership$data = {
  readonly ownerships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly explicitOwner: boolean;
        readonly member: {
          readonly id: string;
          readonly status: {
            readonly value: MemberStatusValue;
          } | null;
        };
        readonly ownerOf: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: string;
            } | null;
          }>;
        };
        readonly " $fragmentSpreads": FragmentRefs<"Owner_ownership">;
      } | null;
    }>;
  };
  readonly " $fragmentType": "ExplicitOwners_ownership";
};
export type ExplicitOwners_ownership$key = {
  readonly " $data"?: ExplicitOwners_ownership$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExplicitOwners_ownership">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExplicitOwners_ownership",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnershipConnection",
      "kind": "LinkedField",
      "name": "ownerships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OwnershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Ownership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Owner_ownership"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "explicitOwner",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Member",
                  "kind": "LinkedField",
                  "name": "member",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "status",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OwnableConnection",
                  "kind": "LinkedField",
                  "name": "ownerOf",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OwnableEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HasOwnerPermissionsInterface",
  "abstractKey": "__isHasOwnerPermissionsInterface"
};

(node as any).hash = "b0dc4d42ab7532582a0e1108616ac421";

export default node;
